import React from 'react';
import { Dropdown as AntDropdown, DropDownProps } from 'antd';

export const Dropdown: React.FC<DropDownProps> = ({ children, ...props }) => {
  return (
    <AntDropdown
      getPopupContainer={(triggerNode: HTMLElement) => triggerNode}
      {...props}
    >
      {children}
    </AntDropdown>
  );
};
